import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getProjectTotalWeight({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.totalWeight : 0;
    },
    getProjectStrategicAxes({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.projectStrategicAxes : [];
    },
    isRetrieveProjectStrategicAxesRequestFailure({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRetrieveProjectStrategicAxesRequestPending({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRetrieveProjectStrategicAxesRequestSuccess({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
